
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Innovacrystaonrentinnavimumbai() {



const cardData = {
  keyword: "Innova Crysta On Rent in Navi Mumbai",
  heading: "Skyline Cabs: Innova Crysta On Rent in Navi Mumbai",
  headingDescription: "Skyline Cabs offers premium Innova Crysta On Rent in Navi Mumbai for corporate travel, airport transfers, wedding events, VIP movement, and long-distance outstation journeys. Our Toyota Innova Crysta fleet is well-maintained, spacious, fully air-conditioned, and driven by professional chauffeurs experienced in city and highway travel. Whether you need Innova Crysta rental Navi Mumbai for business meetings, Innova Crysta airport pickup Navi Mumbai, or Innova Crysta for long trip Navi Mumbai, we provide flexible booking options including hourly, full-day, and outstation packages. With transparent pricing, punctual service, and secure booking support, Skyline Cabs ensures luxury travel experience across Navi Mumbai and beyond.",

  top: "Top Places to Visit in Navi Mumbai with Innova Crysta Rental",

  topPlaces: [
    { title: "Palm Beach Road", description: "Palm Beach Road is one of the most scenic drives in Navi Mumbai, offering smooth highways and coastal views ideal for premium SUV travel like Innova Crysta." },
    { title: "Central Park Kharghar", description: "A massive urban park perfect for family outings, accessible comfortably with spacious Innova Crysta seating." },
    { title: "Belapur Fort", description: "Historic landmark offering panoramic city views, ideal for weekend sightseeing." },
    { title: "Pandavkada Waterfalls", description: "Popular monsoon attraction near Kharghar offering natural beauty and hill views." },
    { title: "Seawoods Grand Central Mall", description: "Premium shopping and entertainment destination in Navi Mumbai." },
    { title: "DY Patil Stadium", description: "Major sports and concert venue requiring comfortable group transportation." },
    { title: "Nerul Balaji Temple", description: "Peaceful spiritual destination visited by families." },
    { title: "Karnala Bird Sanctuary", description: "Nature getaway ideal for weekend trips." },
    { title: "Rock Garden Nerul", description: "Scenic sea-facing location for evening visits." },
    { title: "Utsav Chowk Kharghar", description: "Iconic landmark surrounded by restaurants and cafes." }
  ],

  services: [
    {
      name: "innova crysta on rent in navi mumbai",
      description: "Skyline Cabs provides premium innova crysta on rent in navi mumbai for business travel, family functions, VIP transfers, and comfortable city rides. Our Toyota Innova Crysta vehicles offer spacious seating, powerful performance, and smooth suspension ideal for both city roads and long highway drives. Whether you require hourly booking, full-day rental, or custom trip packages, our innova crysta on rent in navi mumbai service ensures punctual pickup, professional chauffeurs, and sanitized interiors. Designed for comfort and reliability, this service is ideal for corporate clients, wedding transportation, airport transfers, and weekend trips across Maharashtra."
    },
    {
      name: "innova crysta rental navi mumbai",
      description: "Our innova crysta rental navi mumbai service offers flexible rental packages tailored for corporate executives, tourists, and families. With luxury interiors, ample legroom, and strong AC performance, Innova Crysta ensures relaxed travel even during long-distance trips. Skyline Cabs maintains high safety standards, verified drivers, and transparent pricing for every innova crysta rental navi mumbai booking. Customers can choose hourly, daily, or outstation packages with complete fare clarity and dedicated customer support."
    },
    {
      name: "innova crysta hire in navi mumbai",
      description: "Choose innova crysta hire in navi mumbai for premium travel experience backed by professional chauffeurs and well-maintained SUVs. Our fleet is suitable for airport transfers, business meetings, and intercity travel. The innova crysta hire in navi mumbai option guarantees smooth suspension, comfortable seating for up to 6–7 passengers, and ample luggage space, making it perfect for group travel and corporate assignments."
    },
    {
      name: "innova crysta car rental navi mumbai",
      description: "Skyline Cabs offers innova crysta car rental navi mumbai services for weddings, corporate events, airport transfers, and tourism. The vehicle’s luxurious cabin, spacious design, and reliable performance make it a preferred SUV choice. With innova crysta car rental navi mumbai, customers receive flexible booking duration, experienced drivers, and transparent billing."
    },
    {
      name: "innova crysta taxi service navi mumbai",
      description: "Our innova crysta taxi service navi mumbai ensures premium ride quality for city travel and outstation trips. Ideal for executives and families, this service includes comfortable interiors, punctual pickup, and safe driving practices. Skyline Cabs maintains clean and well-serviced vehicles under innova crysta taxi service navi mumbai category."
    },
    {
      name: "book innova crysta in navi mumbai",
      description: "Easily book innova crysta in navi mumbai through our secure online platform or customer support. We provide instant confirmation, clear fare breakdown, and flexible scheduling. The book innova crysta in navi mumbai option ensures convenient reservations for airport pickup, corporate travel, and weekend trips."
    },
    {
      name: "innova crysta rental service navi mumbai",
      description: "Our innova crysta rental service navi mumbai includes chauffeur-driven luxury SUV rentals for business and leisure travel. The service ensures smooth long-distance highway travel and reliable city connectivity. Skyline Cabs guarantees transparent pricing and punctual departure."
    },
    {
      name: "best innova crysta on rent navi mumbai",
      description: "Recognized as best innova crysta on rent navi mumbai provider, Skyline Cabs focuses on comfort, safety, and premium service standards. Customers receive clean vehicles, experienced drivers, and consistent service quality."
    },
    {
      name: "cheapest innova crysta rental navi mumbai",
      description: "We offer cheapest innova crysta rental navi mumbai packages without compromising service quality. Transparent fare structure and competitive pricing ensure affordable luxury SUV travel."
    },
    {
      name: "innova crysta airport pickup navi mumbai",
      description: "Our innova crysta airport pickup navi mumbai service includes real-time flight tracking and punctual arrival. Ideal for business travelers and families requiring smooth airport transfers."
    },
    {
      name: "innova crysta airport drop navi mumbai",
      description: "Choose innova crysta airport drop navi mumbai for timely departure planning with professional chauffeurs and spacious luggage capacity."
    },
    {
      name: "innova crysta outstation rental navi mumbai",
      description: "Premium innova crysta outstation rental navi mumbai service for long-distance travel including Pune, Nashik, Shirdi, Kolhapur, and Mahabaleshwar trips."
    },
    {
      name: "innova crysta for long trip navi mumbai",
      description: "Comfortable innova crysta for long trip navi mumbai designed for highway journeys with smooth suspension and luxury seating."
    },
    {
      name: "innova crysta on rent in vashi",
      description: "Special innova crysta on rent in vashi service offering quick pickup within Vashi and nearby Navi Mumbai sectors."
    }
  ],

  tableData: [
    ["innova crysta on rent in navi mumbai", "innova crysta rental navi mumbai"],
    ["innova crysta hire in navi mumbai", "innova crysta car rental navi mumbai"],
    ["innova crysta taxi service navi mumbai", "book innova crysta in navi mumbai"],
    ["innova crysta rental service navi mumbai", "best innova crysta on rent navi mumbai"],
    ["cheapest innova crysta rental navi mumbai", "innova crysta airport pickup navi mumbai"],
    ["innova crysta airport drop navi mumbai", "innova crysta outstation rental navi mumbai"],
    ["innova crysta for long trip navi mumbai", "innova crysta on rent in vashi"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Premium SUV Comfort & Spacious Seating",
      WhyChoosedescription: "Our Innova Crysta fleet provides luxury seating, spacious interiors, powerful AC, and smooth suspension ideal for long-distance and city travel. Customers experience superior ride comfort with high safety standards and professional chauffeurs ensuring relaxed journeys."
    },
    {
      WhyChooseheading: "Experienced & Verified Chauffeurs",
      WhyChoosedescription: "All drivers are background-verified, professionally trained, and experienced in highway as well as city routes ensuring safe and punctual travel."
    },
    {
      WhyChooseheading: "Transparent Pricing & No Hidden Charges",
      WhyChoosedescription: "Clear fare breakdown for all Innova Crysta rental services without unexpected costs or hidden fees."
    },
    {
      WhyChooseheading: "24x7 Booking & Airport Availability",
      WhyChoosedescription: "Round-the-clock availability for airport pickup, drop, and urgent bookings with instant confirmation."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Hourly, full-day, one-way, and outstation packages tailored for customer convenience."
    },
    {
      WhyChooseheading: "Clean & Well-Maintained Fleet",
      WhyChoosedescription: "Vehicles undergo regular maintenance and sanitization ensuring hygienic travel."
    },
    {
      WhyChooseheading: "Corporate & Event Friendly",
      WhyChoosedescription: "Ideal for executive meetings, weddings, VIP movement, and group travel."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription: "Dedicated support team assisting customers before, during, and after booking."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book Innova Crysta On Rent in Navi Mumbai with Skyline Cabs?',
        answer:
            'Booking Innova Crysta On Rent in Navi Mumbai with Skyline Cabs is quick and simple. Visit our website or mobile app, select Innova Crysta from the vehicle list, enter your pickup and drop location, choose your travel date, and confirm instantly. You receive immediate booking confirmation along with driver details. Our process is transparent, fast, and hassle-free for customers.',
    },
    {
        id: 2,
        question: 'What is the fare for Innova Crysta On Rent in Navi Mumbai?',
        answer:
            'The fare for Innova Crysta On Rent in Navi Mumbai depends on trip type such as local, airport transfer, or outstation travel. Skyline Cabs provides competitive and transparent pricing that includes driver allowance and applicable charges. There are no hidden costs, and the final price is shown before booking confirmation.',
    },
    {
        id: 3,
        question: 'Is Innova Crysta available for outstation trips from Navi Mumbai?',
        answer:
            'Yes, our Innova Crysta On Rent in Navi Mumbai service is perfect for outstation trips to destinations like Pune, Lonavala, Mahabaleshwar, Nashik, Kolhapur, and Shirdi. The vehicle provides superior comfort for long-distance travel with spacious seating and ample luggage capacity.',
    },
    {
        id: 4,
        question: 'Is Innova Crysta suitable for family travel?',
        answer:
            'Absolutely. Innova Crysta is one of the most preferred vehicles for family trips because of its comfortable seating, powerful AC, smooth suspension, and spacious interior. It comfortably accommodates 6–7 passengers with luggage, making it ideal for group travel.',
    },
    {
        id: 5,
        question: 'Do you provide Innova Crysta for airport transfers in Navi Mumbai?',
        answer:
            'Yes, Skyline Cabs offers Innova Crysta On Rent in Navi Mumbai for airport pickup and drop services. We track flight schedules to ensure timely pickup and provide clean, sanitized vehicles for stress-free airport travel.',
    },
    {
        id: 6,
        question: 'Is online payment available for Innova Crysta booking?',
        answer:
            'Yes, we support secure online payment options including UPI, credit cards, debit cards, and net banking. Once payment is completed, you receive instant confirmation along with ride details.',
    },
    {
        id: 7,
        question: 'Can I pre-book Innova Crysta in Navi Mumbai?',
        answer:
            'Yes, you can pre-book Innova Crysta On Rent in Navi Mumbai for weekends, holidays, corporate events, weddings, and special occasions. Advance booking ensures guaranteed availability.',
    },
    {
        id: 8,
        question: 'Is the driver included with Innova Crysta rental?',
        answer:
            'Yes, Skyline Cabs provides professional and experienced chauffeurs with every Innova Crysta rental. Our drivers are trained, courteous, and familiar with Navi Mumbai routes and highways for safe travel.',
    },
    {
        id: 9,
        question: 'Is Innova Crysta On Rent in Navi Mumbai available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Innova Crysta rental service in Navi Mumbai. Whether you need early morning travel or late-night pickup, we are available round the clock.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Innova Crysta On Rent in Navi Mumbai?',
        answer:
            'Skyline Cabs is trusted for Innova Crysta On Rent in Navi Mumbai because we provide clean vehicles, professional drivers, transparent pricing, punctual service, and 24x7 customer support. We focus on delivering premium comfort and reliable travel experience every time.',
    },
];

const services = [
    {
        title: "Local Innova Crysta Rental in Navi Mumbai",
        description:
            "Skyline Cabs provides premium Innova Crysta On Rent in Navi Mumbai for local city travel, corporate meetings, shopping trips, and family outings. The vehicle offers superior comfort with spacious seating and smooth suspension for city roads. Our professional drivers ensure timely pickups and safe navigation through traffic. With transparent pricing and well-maintained vehicles, we guarantee a stress-free and comfortable local ride experience."
    },
    {
        title: "Airport Transfer Innova Crysta Service",
        description:
            "Our Innova Crysta On Rent in Navi Mumbai is highly preferred for airport transfers due to its spacious luggage capacity and comfortable seating. We monitor flight timings to ensure punctual pickup and drop services. The vehicle is sanitized and well-maintained for safe travel. Whether it’s Mumbai Airport or Navi Mumbai Airport, Skyline Cabs ensures a smooth, professional, and hassle-free airport journey."
    },
    {
        title: "Outstation Innova Crysta Rental",
        description:
            "Planning a long trip from Navi Mumbai? Our Innova Crysta On Rent in Navi Mumbai is ideal for outstation travel to Pune, Mahabaleshwar, Shirdi, Kolhapur, and more. The vehicle’s powerful engine and premium interiors make long-distance journeys comfortable and relaxing. With experienced chauffeurs and transparent billing, Skyline Cabs ensures a safe and enjoyable highway travel experience."
    },
    {
        title: "Corporate & Event Innova Crysta Rental",
        description:
            "Skyline Cabs offers Innova Crysta On Rent in Navi Mumbai for corporate events, executive travel, weddings, and special occasions. The premium look and comfort of Innova Crysta make it suitable for VIP guests and business executives. We provide punctual service, professional drivers, and billing support for corporate clients. Our goal is to deliver premium travel experience with reliability and elegance."
    }
];

const someReviews = [
    {
        name: "Mr. Rajesh Patil",
        rating: 5,
        review: "Booked Innova Crysta On Rent in Navi Mumbai with Skyline Cabs for an outstation trip. The vehicle was extremely comfortable and the driver was professional. Smooth and safe journey throughout!"
    },
    {
        name: "Mrs. Neha Shah",
        rating: 4,
        review: "Very satisfied with Innova Crysta rental service in Navi Mumbai. Clean car, punctual pickup, and transparent pricing. Skyline Cabs provides reliable and premium service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/innova-crysta-rent-navi-mumbai.jpg",
  "description": "Rent Innova Crysta in Navi Mumbai with Skyline Cabs for airport pickup, drop, local and outstation travel. Affordable and reliable Innova Crysta rental service available in Vashi, Nerul, Kharghar, Panvel with AC cars and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/innova-crysta-on-rent-navi-mumbai"
  }
};




    return (
        <div>

<Helmet>
  <title>Innova Crysta On Rent in Navi Mumbai | AC Rental & Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Innova Crysta in Navi Mumbai with Skyline Cabs for airport transfers, local travel, and outstation trips. Reliable and affordable AC Innova Crysta with professional drivers available 24x7." 
  />
  <meta 
    name="keywords" 
    content="innova crysta on rent in navi mumbai, innova crysta rental navi mumbai, innova crysta hire in navi mumbai, innova crysta car rental navi mumbai, innova crysta taxi service navi mumbai, book innova crysta in navi mumbai, innova crysta rental service navi mumbai, best innova crysta on rent navi mumbai, cheapest innova crysta rental navi mumbai, innova crysta airport pickup navi mumbai, innova crysta airport drop navi mumbai, innova crysta outstation rental navi mumbai, innova crysta for long trip navi mumbai, innova crysta on rent in vashi, innova crysta on rent in nerul, innova crysta on rent in kharghar, innova crysta on rent in panvel, ac innova crysta on rent in navi mumbai, Skyline Cabs Innova Crysta Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/127.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystaonrentinnavimumbai;